import React from 'react';
import ReactModal from 'react-modal';

import styles from './mask-layer.css';

const MaskLayer = () => (
    <ReactModal
        isOpen
        className={styles.modalContent}
        overlayClassName={styles.modalOverlay}
    >
        <div className={styles.illustration} />
    </ReactModal>
);

export default MaskLayer;
